export const formatTitleCase = (
	value: string,
	locale: Intl.LocalesArgument = 'en-US'
): string =>
	value
		.toLocaleLowerCase(locale)
		.replace(
			/\S+/g,
			word => `${word.charAt(0).toLocaleUpperCase(locale)}${word.slice(1)}`
		);
